<template>
  <MainLayout>
    <div class="stationListStyle">
      <!-- 头部 -->
      <div class="header">
        <div style="flex:1 1 0"></div>
        <div v-if="csvOutFlag" class="name-strong F3-M-27" style="flex:1">[出力]停留所リスト</div>
        <div v-else class="name-strong F3-M-27" style="flex:1">停留所リスト</div>
        <div class="btn-position" style="flex:1">
          <div></div>
          <div class="common-btn F2-M-19" @click="csvOut">一覧出力</div>
          <div class="common-btn F2-M-19" @click="login">+ 新規登録</div>
        </div>
      </div>

      <!-- 主体 -->
      <div class="body">
        <!-- 左侧列表 -->
        <div class="body-left">
          <div class="table-hader">
            <table style="width:100%">
              <thead>
                <tr class="theader bgc9">
                  <td class="station-trborder" style="width:8%" v-show="csvOutFlag">
                    <input type="checkbox" v-model="allChecked" style="height:20px;width:20px;margin-left:0px;" @change ="allCheckEvent">
                   </td>
                  <td class="station-trborder" style="width:8%" v-show="!csvOutFlag"></td>
                  <td class="station-trborder" style="width:10%;min-width:70px;">停留所ID</td>
                  <td class="station-trborder" style="width:40%">停留所名/所在地</td>
                  <td class="station-trborder" style="width:25%;min-width:210px;">備考</td>
                  <td class="station-trborder" style="width:12%;min-width:80px;"></td>
                </tr>
              </thead>
            </table>
          </div>
          <div class="tablebody slider">
            <table style="width:100%">
              <tbody>
                <tr class="station-contenttr bgc5h" :class="{active: item.active} " v-for='(item, index) in stationDataList' :key="index" @click="getPoint(item, index)">
                  <td class="station-trborder" style="width:8%;text-align: center" v-show="csvOutFlag">
                    <input type="checkbox" v-model="item.isChecked" style="height:20px;width:20px;margin-left:0px;">
                  </td>
                  <td class="station-trborder bodytext columnWidth1 F1-R-18" style="width:8%;text-align: center;padding-left: 0px;" v-show="!csvOutFlag">{{index+1}}</td>
                  <td class="station-trborder bodytext columnWidth2 F1-R-18" style="width:10%;text-align: center;min-width:70px;padding-left: 0px;">{{item.displayStationId}}</td>
                  <td class="station-trborder bodytext columnWidth3" :style="stationDataList.length > 7 ? 'width:40%' : 'width:39%'">
                    <p class="column-station-name F1-R-20">
                      <img src="../../assets/icon/transport_kind0.png" style="height: 32px;width:32px;" v-if="item.transportKind=='0'">
                      <img src="../../assets/icon/transport_kind1.png" style="height: 32px;width:32px;" v-if="item.transportKind=='1'">
                      <img src="../../assets/icon/office_flag0.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="item.officeFlag=='0'">
                      <img src="../../assets/icon/office_flag1.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="item.officeFlag=='1'">
                      {{item.stationName}}
                    </p>
                    <p class="column-station-place F3-R-15">
                      {{item.address}}
                    </p>
                  </td>
                  <td class="station-trborder bodytext  F1-R-16" style="width:25%">
                    <div class="columnWidth4">
                      {{item.note}}
                    </div>
                  </td>
                  <td class="station-trborder bodytext columnWidth5" style="width:12%;min-width:80px;">
                    <div class="detailed detailed-button" @click="openStationDetail(item)">
                      <div class="F2-M-16">詳細</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 右侧地图 -->
        <div class="body-right">
          <div class="mapCss">
            <google-map ref="gMap" :center-point="centerPoint" :map-id="mapId" />
          </div>
        </div>
      </div>

      <!--底部-->
      <div class="row clearfix footer" v-show="csvOutFlag">
          <div class="col-md-6 column">
              <button class="foot-button" style="float:right" @click="doPrint">出力</button>
          </div>
          <div class="col-md-6 column">
              <button class="foot-button" style="float:left" @click="cancelPrint">キャンセル</button>
          </div>
      </div>
      <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '../layouts/mainLayout'
import googleMap from '@/components/googleMap'
import dialog from '@/components/Dialog'
// import apiConfig from '../../../config/api.config'
import axios from 'axios'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'
import STATION_ICON2 from '@/assets/map_icon/map_stop_point2.png'
// import _ from 'lodash'

export default {
  data () {
    return {
      mapId: 'mapStation',
      // 地图中心点
      centerPoint: {},
      // 地图标记点List
      stationDataList: [],
      // 一览出力按钮按下否
      csvOutFlag: false,
      // 标题栏全选按钮按下否
      allChecked: false,

      // 确认框属性
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      // 是否弹出确认框
      showPrintDialog: false,
      // 地图图标标记点
      pointDataList: [],
      marker: null,
      markerList: [],
      bgc: ''
    }
  },
  components: { MainLayout, googleMap, 'v-dialog': dialog },
  beforeMount () {
    this.setMark()
  },
  mounted () {
  },
  methods: {
    popWindow () {
      document.getElementById('modal-stay').click()
    },
    login () {
      sessionStorage.setItem('windowType', 1)
      this.$router.push({ path: '/StationListRegistration' })
    },
    // 初始化图标
    async setMark () {
      try {
        const { data } = await axios.post('station/getStationData')
        // this.stationDataList = _.dropRight(data.stationData, 55)
        this.stationDataList = data.stationData
        for (let i = 0; i < this.stationDataList.length; i++) {
          this.stationDataList[i].isChecked = false
        }

        if (this.stationDataList != null && this.stationDataList.length > 0) {
          await this.$refs.gMap.initializeGoogleMap()
          this.centerPoint = {
            lng: this.stationDataList[0].stationLng,
            lat: this.stationDataList[0].stationLat
          }
          this.$refs.gMap.map.setZoom(14)
          this.$refs.gMap.centerPointObj = this.centerPoint

          let index = 0
          for (const i of this.stationDataList) {
            index += 1
            let markPosition = {
              label: index,
              lng: i.stationLng,
              lat: i.stationLat,
              icon: index === 1 ? STATION_ICON : STATION_ICON2
            }
            let imgSize01 = {width: 60, height: 80}
            // 图标里面的字体样式
            let labelAnchor01 = {width: 30, height: 70}
            let className01 = 'staion01-label-class'

            // 添加图标
            let imgSize02 = {width: 45, height: 60}
            // 图标里面的字体样式
            let labelAnchor02 = {width: 23, height: 53}
            let className02 = 'staion02-label-class'

            this.marker = this.$refs.gMap.addSingleMaker(markPosition,
              index === 1 ? imgSize01 : imgSize02,
              index === 1 ? className01 : className02,
              index === 1 ? labelAnchor01 : labelAnchor02
            )
            this.markerList.push(this.marker)
          }
        }
      } catch (e) {
        const message = e.statusText
        console.log(message)
      }
    },
    // 单击停留所Row, 将该点设为地图中心
    getPoint (item, k) {
      // 改变选中行的颜色
      this.stationDataList.map(o => {
        if (o.active || o.active === undefined) {
          this.$set(o, 'active', false)
        }
        this.$set(item, 'active', true)
      })
      // 清除坐标点
      for (const y of this.markerList) {
        y.setMap(null)
      }
      let centerPoint = {
        lat: parseFloat(item.stationLat),
        lng: parseFloat(item.stationLng)
      }
      // 坐标和图标参数
      let pointDataList = {stationId: k + 1, stationLng: item.stationLng, stationLat: item.stationLat}
      sessionStorage.setItem('pointDataList', JSON.stringify(pointDataList))
      this.$refs.gMap.map.setZoom(16)
      this.$refs.gMap.map.setCenter(centerPoint)

      let index = 0
      for (const i of this.stationDataList) {
        index += 1
        let markPosition = {
          label: index,
          lng: i.stationLng,
          lat: i.stationLat,
          icon: item === i ? STATION_ICON : STATION_ICON2
        }
        let imgSize01 = {width: 60, height: 80}
        // 图标里面的字体样式
        let labelAnchor01 = {width: 30, height: 70}
        let className01 = 'staion01-label-class'

        // 添加图标
        let imgSize02 = {width: 45, height: 60}
        // 图标里面的字体样式
        let labelAnchor02 = {width: 23, height: 53}
        let className02 = 'staion02-label-class'

        this.marker = this.$refs.gMap.addSingleMaker(markPosition,
          item === i ? imgSize01 : imgSize02,
          item === i ? className01 : className02,
          item === i ? labelAnchor01 : labelAnchor02
        )
        this.markerList.push(this.marker)
      }
    },
    // 打开停留所详细画面
    openStationDetail (data) {
      sessionStorage.setItem('stationViewModel', JSON.stringify(data))
      this.$router.push({ name: 'StationDetail' })
    },

    // 一览出力 事件
    csvOut () {
      // 显示checkBox和底部按钮
      this.csvOutFlag = true
    },
    // 出力
    doPrint () {
      // 打印列表
      let printList = []
      for (let i = 0; i < this.stationDataList.length; i++) {
        if (this.stationDataList[i].isChecked) {
          printList.push(this.stationDataList[i])
        }
      }

      // 根据是否勾选数据,弹出不同的确认框
      if (printList.length === 0) {
        let dialogPrintOption = {
          showNo: false,
          text: '停留所を選択してください。',
          confirmButtonText: 'OK'
        }
        this.dialogPrintOption = dialogPrintOption

        this.showPrintDialog = true
        this.$refs.printDialog.confirm().then(() => {
          this.showPrintDialog = false
        })
          .catch(() => {
            this.showPrintDialog = false
          })
      } else {
        let dialogPrintOption = {
          showNo: true,
          text: 'データをダウンロードします。<br/>よろしいですか？',
          cancelButtonText: 'キャンセル',
          confirmButtonText: '実行'
        }
        this.dialogPrintOption = dialogPrintOption

        this.showPrintDialog = true
        this.$refs.printDialog.confirm().then(() => {
          axios({
            method: 'post',
            url: 'station/downloadCsvFile',
            data: printList,
            responseType: 'blob'
          }).then(response => {
            let url = window.URL.createObjectURL(new Blob([response.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', '停留所リスト.csv')
            document.body.appendChild(link)
            link.click()
          }).catch((error) => {
            console.log(error)

            let dialogPrintOption = {
            showNo: false,
            text: '予期せぬエラーが発生しました。',            
            confirmButtonText: 'OK'
            }
            this.dialogPrintOption = dialogPrintOption
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            })
          })

          this.showPrintDialog = false
        }).catch(() => {
          this.showPrintDialog = false
        })
      }
    },
    // 取消
    cancelPrint () {
      // 不显示CheckBox
      this.csvOutFlag = false

      // 恢复到全部不勾选状态
      this.allChecked = false
      this.allCheckEvent()
    },
    // 全选
    allCheckEvent () {
      for (let i = 0; i < this.stationDataList.length; i++) {
        if (this.allChecked) {
          this.stationDataList[i].isChecked = true
        } else {
          this.stationDataList[i].isChecked = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.stationListStyle {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    // 头部
    .header {
        display: flex;
        flex-direction: row;
        padding-top: 20px;
        flex: 0 0 60px;
        // 右侧按钮
        .btn-position {
          display: flex;
          & > div {
            flex: 1;
            margin-right: 15px;
          }
        }
    }
    .body {
        display: flex;
        flex: 1 1 0;
        margin: 25px 20px 20px 20px;
        .body-left {
            display: flex;
            flex-direction: column;
            flex: 1 1 0;
            padding-right: 25px;
            .table-hader {
              height: 30px;
              padding-right: 28px;
            }
            .tablebody {
                min-height: 0px;
                padding: 5px 25px 0px 0px;
                flex: 1 1 0;
                .station-contenttr {
                    background-color: rgb(219, 219, 219);
                    height: 50px;
                    margin-top: 20px;
                    font-size: 18px;
                    // border-bottom: 1px solid rgb(110, 110, 110);
                    // border-top: 1px solid #fff;
                    // border-right: 1px solid rgb(179, 172, 172);
                    // border-bottom: 1px solid rgb(153, 149, 149);
                    &:hover {
                      background-color: #c7dcdf;
                      cursor: pointer;
                    }
                    &:active {
                      background-color: #c7dcdf;
                    }
                    .detailed {
                      cursor: pointer;
                      border-radius: 5px;
                      font-weight: 600;
                      color: white;
                      height: 30px;
                      background-color: #91928d;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      &:active {
                        background-color: #a7a7a5;
                      }
                    }
                }
                .active {
                  background-color: rgb(180, 210, 220) !important
                }
            }
        }
        // 主体右侧样式
        .body-right {
            flex: 1 1 0;
            padding: 0px;
            .mapCss {
                width: 100%;
                height: 100%;
            }
        }
    }
    .footer {
      flex: 0 0 70px !important;
    }
}

.name-strong {
    font-size: 30px;
    font-weight: bold;
    /* padding: 20px; */
}

.column-index {
    font-size: 20px;
    padding-top: 25px;
}
.column-station-name {
    font-size: 20px;
    text-align: left;
    padding-top: 10px;
    // 字体自动换行
    word-break: break-all;
}
.column-station-place {
    font-size: 15px;
    text-align: left;
}
table {
  border-collapse: collapse;
  border-spacing: 0px 5px;
  overflow-y: auto;
  margin-right: 20px;
  .theader {
      color: white;
      height: 30px;
      background-color: rgb(110, 110, 110);
      font-size: 14px;
  }
  .columnWidth1 {
      width: 10%;
  }
  .columnWidth2 {
      width: 20%;
  }
  .columnWidth3 {
      width: 20%;
  }
  .columnWidth4 {
      width: 200px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
  }
  .columnWidth5 {
      width: 17%;
      padding: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
  }
}
.station-trborder {
  border-top: 1px solid #fff;
  border-bottom: 1px solid rgb(153, 149, 149);
  border-right: 1px solid rgb(179, 172, 172);
}
.bodytext {
  height: 25px;
  padding-left: 15px;
}

</style>



// WEBPACK FOOTER //
// src/router/views/StationList.vue